module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hres3cu-detail-process-popup",
      "id": "hres3cu-detail-process-popup",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    ref: "detailPopupProcessModalButton",
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC3']['10']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC3']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "detail-text width-100"
  }, [_vm._v(_vm._s(_vm.indexSelected.numcom))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC3']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "name": "dteopert",
      "data-vv-value-path": "inputDate",
      "has-error": _vm.errors.has('dteopert')
    },
    model: {
      value: (_vm.paramDetailProcess.dteopert),
      callback: function($$v) {
        _vm.$set(_vm.paramDetailProcess, "dteopert", $$v)
      },
      expression: "paramDetailProcess.dteopert"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteopert')),
      expression: "errors.has('dteopert')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteopert')))])], 1)])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(" " + _vm._s(_vm.labels['HRES3CUC3']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('hrms-lov', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "nowLang": _vm.nowLang,
      "lovType": "codempid",
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codopert",
      "name": "codopert"
    },
    model: {
      value: (_vm.paramDetailProcess.codopert),
      callback: function($$v) {
        _vm.$set(_vm.paramDetailProcess, "codopert", $$v)
      },
      expression: "paramDetailProcess.codopert"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codopert')),
      expression: "errors.has('codopert')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codopert')))])], 1)])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC3']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramDetailProcess.desopert),
      expression: "paramDetailProcess.desopert"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:200'),
      expression: "'required|max:200'"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "200",
      "data-vv-name": "desopert",
      "has-error": _vm.errors.has('desopert')
    },
    domProps: {
      "value": (_vm.paramDetailProcess.desopert)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paramDetailProcess, "desopert", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(200)))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desopert')),
      expression: "errors.has('desopert')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desopert')))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC3']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramDetailProcess.limopert),
      expression: "paramDetailProcess.limopert"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:200'),
      expression: "'max:200'"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "200",
      "data-vv-name": "limopert",
      "has-error": _vm.errors.has('limopert')
    },
    domProps: {
      "value": (_vm.paramDetailProcess.limopert)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paramDetailProcess, "limopert", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('limopert')),
      expression: "errors.has('limopert')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('limopert')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(200)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC3']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramDetailProcess.resopert),
      expression: "paramDetailProcess.resopert"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:dteres|max:200'),
      expression: "'requiredWhenExist:dteres|max:200'"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "200",
      "data-vv-name": "resopert",
      "name": "resopert",
      "has-error": _vm.errors.has('resopert')
    },
    domProps: {
      "value": (_vm.paramDetailProcess.resopert)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paramDetailProcess, "resopert", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('resopert')),
      expression: "errors.has('resopert')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('resopert')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(200)))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC3']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:resopert|date_format:DD/MM/YYYY'),
      expression: "'requiredWhenExist:resopert|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteres",
      "has-error": _vm.errors.has('dteres')
    },
    model: {
      value: (_vm.paramDetailProcess.dteres),
      callback: function($$v) {
        _vm.$set(_vm.paramDetailProcess, "dteres", $$v)
      },
      expression: "paramDetailProcess.dteres"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteres')),
      expression: "errors.has('dteres')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteres')))])], 1)])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES3CUC3']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentDate),
      expression: "currentDate"
    }],
    attrs: {
      "type": "hidden",
      "name": "currentDate"
    },
    domProps: {
      "value": (_vm.currentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('date_format:DD/MM/YYYY|before:currentDate'),
      expression: "'date_format:DD/MM/YYYY|before:currentDate'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteclose",
      "has-error": _vm.errors.has('dteclose')
    },
    model: {
      value: (_vm.paramDetailProcess.dteclose),
      callback: function($$v) {
        _vm.$set(_vm.paramDetailProcess, "dteclose", $$v)
      },
      expression: "paramDetailProcess.dteclose"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-error"
  }, [_vm._v("** " + _vm._s(_vm.hres3cuLabels[_vm.nowLang]['10']) + " ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteclose')),
      expression: "errors.has('dteclose')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteclose')))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer align-left"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['save']))]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8edb0f08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres3cu/popupProcess.vue
// module id = 3925
// module chunks = 1